import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IOffice, IOfficeCatalog, IOfficeSelect } from '../interfaces/domain/office.interface';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.dev';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class OfficesService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiPath:string = `${environment.services.api}/offices`;

  constructor() {}

  getOffices(forCatalog: boolean = false): Observable<IOffice[] | IOfficeCatalog[]> {
    const request = this.http.get<IOffice[]>(this.apiPath);

    if (forCatalog) {
      return request.pipe(
        map((offices: IOffice[]) => {
          return offices.map((office: IOffice) => ({
            id: office.id,
            // name: `${office.name} - ${ office.address.city || ''} (${ office.address.state || ''}, ${ office.address.country || ''})`,
            name: `${office.name} (${ office.address.country || ''})`,
            managers: office.managers
          }));
        })
      ) as Observable<IOfficeCatalog[]>
    }

    return request;
  }

  getAllOfficesForSelector(): Observable<IOfficeSelect[]> {
    const request = this.http.get<IOffice[]>(this.apiPath);

    return request.pipe(
      map((offices: IOffice[]) => {
        return offices.map((office: IOffice) => ({
          id: String(office.id),
          name: office.name,
          currencyType: office.currencyType
        }));
      })
    ) as Observable<IOfficeSelect[]>
  }
}
